import { render, staticRenderFns } from "./UserQualificationForm.vue?vue&type=template&id=5fb2e05e&"
import script from "./UserQualificationForm.vue?vue&type=script&lang=js&"
export * from "./UserQualificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports